import {
  PropertyTranslator,
  IGenericRequestParametersTranslator,
  IPaginationParametersTranslator,
  IOwnedEntityParametersTranslator,
  ISoftDeletableFilterParametersTranslator,
  IEntryRecordParametersTranslator,
  IModifiedRecordParametersTranslator,
  INamedEntityParametersTranslator,
  IProjectBasedParametersTranslator,
  IEntryRecordLabels,
  ICustomTypedEntityLabels,
  IModificationRecordLabels,
  INamedEntityLabels,
  IPermissionedEntityLabels,
  IUniqueEntityLabels,
  ISoftDeletableLabels,
  IRelatedEntityLabels,
  ILockableEntityLabels,
  ILockableEntityParametersTranslator,
  ISignableEntityLabels,
  ISignableEntityParametersTranslator,
  ITypedEntityParametersTranslator,
} from "./GenericTranslator";
import {
  IModelWithIntId,
  IPermissionedEntity,
  IProjectBasedResponseModel,
  IOwnedEntity,
  IRelatedEntity,
  IRelationModel,
  IPaginationParameters,
  IGenericRequestParameters,
  IRelation,
  IUniqueEntity,
  ISoftDeletable,
  ISoftDeletableFilterParameters,
  IOwnedEntityParameters,
  EntityConstants,
  GenericEntityOrderBy,
  ICustomTypedEntity,
  TypedEntitySuggestionsModel,
  INamedEntity,
  IEntryRecord,
  IModificationRecord,
  EntryRecordOrderBy,
  ModificationRecordOrderBy,
  ICreatedRecordParameters,
  IModifiedRecordParameters,
  INamedEntityParameters,
  IProjectBasedParameters,
  ILockableEntity,
  ILockableEntityParameters,
  ISignableEntity,
  ISignableEntityParameters,
  ITypedEntityParameters,
  NamedEntityOrderBy,
  TypedEntityOrderBy,
  OwnedOrderBy,
} from "./GenericTypes";

export const samplesConstants: EntityConstants<Sample, SampleFilters> = {
  resource: "samples",
  frontendIndexRoute: "samples",
  entitySingular: "sample",
  entityPlural: "samples",
  icon: "test-tube-diagonal",
};

export interface Sample
  extends IModelWithIntId,
    IPermissionedEntity,
    IProjectBasedResponseModel,
    IOwnedEntity,
    IRelatedEntity<SampleRelations>,
    IUniqueEntity,
    ISoftDeletable,
    ICustomTypedEntity,
    INamedEntity,
    IEntryRecord,
    IModificationRecord,
    ILockableEntity,
    ISignableEntity {}

export const SampleFieldLabels: PropertyTranslator<Sample> = {
  ...INamedEntityLabels,
  ...IPermissionedEntityLabels,
  ...IEntryRecordLabels,
  ...IModificationRecordLabels,
  ...ICustomTypedEntityLabels,
  ...IUniqueEntityLabels,
  ...IPermissionedEntityLabels,
  ...ISoftDeletableLabels,
  ...ILockableEntityLabels,
  ...IRelatedEntityLabels,
  ...ISignableEntityLabels,
  id: "Sample ID",
  owner: "Owned by",
  projects: "Projects",
} as const;

export interface SampleSuggestions extends TypedEntitySuggestionsModel<Sample["id"]> {}

export interface SampleRelations extends IRelationModel {
  labNotebookEntries: IRelation;
}

export const SampleSortingOptionsConsts = [
  ...GenericEntityOrderBy,
  ...NamedEntityOrderBy,
  ...TypedEntityOrderBy,
  ...EntryRecordOrderBy,
  ...ModificationRecordOrderBy,
  ...OwnedOrderBy,
] as const;
export type SampleSortingOptions = (typeof SampleSortingOptionsConsts)[number];

export interface SampleFilters
  extends IPaginationParameters,
    IGenericRequestParameters<Sample, SampleSortingOptions>,
    ISoftDeletableFilterParameters,
    IOwnedEntityParameters,
    ICreatedRecordParameters,
    IModifiedRecordParameters,
    INamedEntityParameters,
    IProjectBasedParameters,
    ITypedEntityParameters,
    ILockableEntityParameters,
    ISignableEntityParameters {
  customFields?: {
    [property: string]: string;
  } | null;
}

export const SampleFiltersTranslator: PropertyTranslator<SampleFilters> = {
  ...IGenericRequestParametersTranslator,
  ...IPaginationParametersTranslator,
  ...ITypedEntityParametersTranslator,
  ...ISoftDeletableFilterParametersTranslator,
  ...IOwnedEntityParametersTranslator,
  ...IEntryRecordParametersTranslator,
  ...IModifiedRecordParametersTranslator,
  ...INamedEntityParametersTranslator,
  ...IProjectBasedParametersTranslator,
  ...ILockableEntityParametersTranslator,
  ...ISignableEntityParametersTranslator,
  customFields: "Custom fields",
} as const;

export const SampleSearchTermOptions = {
  searchTermIncludeNames: SampleFiltersTranslator["searchTermIncludeNames"],
  searchTermIncludeIds: SampleFiltersTranslator["searchTermIncludeIds"],
  searchTermIncludeUuids: SampleFiltersTranslator["searchTermIncludeUuids"],
  searchTermIncludeCustomFieldValues: SampleFiltersTranslator["searchTermIncludeCustomFieldValues"],
} as const;
